/* eslint-disable */
import { lazy, Suspense, useContext } from 'react';
import { Outlet, Navigate, useRoutes, RouteObject } from 'react-router-dom';
import LoginPage from '../pages/login';
import IndexPage from '../pages/overview/view/app-view';
import DataViewPage from '../pages/data/view/data-view';


import AdminLayout from '../layouts/admin';
import UserPage from '../pages/user/view/user-view';
import UserEditPage from '../pages/user/edit/user-edit';
import UserAddPage from '../pages/user/add/user-add';
import SettingPage from '../pages/admin/settings/setting-page';
import RegisterPage from '../pages/register';
import ForgotPasswordPage from '../pages/forgot-password';
import ResetPasswordPage from '../pages/reset-password';
import NotFoundPage from '../pages/not-found-view';
import ProfilePage from '../pages/profile';

// ----------------------------------------------------------------------

export default function Router() {

  const routes = [
    {
      path: '/',
      element:  <Navigate to="/admin" replace />,
    },
    {
      path: 'admin',
      element: (
        <AdminLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </AdminLayout>
      ),
      children: [
        { element: <IndexPage />, index: true },
        { path: 'user', element: <UserPage /> },
        { path: 'user/add', element: <UserAddPage /> },
        { path: 'user/:id/edit', element: <UserEditPage /> },

        { path: 'logs', element: <DataViewPage /> },
        
      ],
    },
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: 'admin/register',
      element: <RegisterPage />,
    },
    {
      path: 'admin/profile',
      element: <ProfilePage /> ,
    },
    {
      path: 'admin/forgot-password',
      element: <ForgotPasswordPage />,
    },
    {
      path: 'admin/reset-password/:token',
      element: <ResetPasswordPage />,
    },
    {
      path: '404',
      element: <NotFoundPage />,
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ];

  return useRoutes(routes);
}
